import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { SelectOption } from '@shared/components/multi-select/models';
import { environment } from '@environments/environment';
import { ServerLinkName } from '@shared/models/server-links-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerLinks } from '@shared/services/server-links';
import { CustomIcons } from '@shared/models/custom-icons';
import { DateTime } from 'luxon';
import { AppInfo } from '../models/platfrom';
import { PopularApp, PopularAppsResponse } from '../../../../main/models/mobile-apps';
import { ImpairedSorting } from '../../data/models/data-table';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private _urlEhdapi = '';
  private readonly _httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    'ehd-system': 'opod'
  });
  public sorting: ImpairedSorting = {
    value: 'ASC',
    type: 'name'
  };
  public allApp: AppInfo[] = [];

  public filterApp = new BehaviorSubject<AppInfo[]>([]);
  public categories: SelectOption[];
  public platforms: SelectOption[] = [
    {
      title: 'Android',
      value: 'Android',
      isSelected: true
    },
    {
      title: 'Windows Phone',
      value: 'Windows Phone',
      isSelected: true
    },
    {
      title: 'iOS',
      value: 'iOS',
      isSelected: true
    }
  ];

  constructor(private http: HttpClient, serverLinks: ServerLinks) {
    this._urlEhdapi = serverLinks.getLink(ServerLinkName.EhdApi);
  }

  // eslint-disable-next-line consistent-return
  private static getIcons(platformName: string): CustomIcons | undefined {
    // eslint-disable-next-line default-case
    switch (platformName) {
      case 'iOS':
        return CustomIcons.Ios;
      case 'Android':
        return CustomIcons.Android;
      case 'Windows Phone':
        return CustomIcons.Windows;
      default:
        return undefined;
    }
  }

  public getAllPlatforms(): Observable<AppInfo[]> {
    const popularAppCatalogId = environment.popularAppCatalogId;
    const body = { id: popularAppCatalogId, criteria: '', sorting: { Name: 'ASC' } }; // `Public_status = 'Опубликовано' and is_deleted=0`

    if (this.allApp.length > 0) {
      return of(this.allApp);
    }

    return this.http.post<PopularAppsResponse>(`${this._urlEhdapi}catalog/get/`, body, { headers: this._httpHeaders }).pipe(
      map(res => res.response),
      map(response => {
        const mapResponse = response?.map((app: PopularApp) => {
          const appStores = app.Platform_data.map(platform => ({
            name: platform.Platform,
            platform: platform.Platform,
            store: platform.applic_store,
            link: platform.Link,
            icon: AppStateService.getIcons(platform.Platform)!,
          }));

          return {
            id: app.global_id,
            name: app.Name,
            appStores,
            description: app.Description,
            category: app.Category_app,
            publicationDate: DateTime.fromFormat(app.signature_date, 'dd.MM.yyyy hh:mm:ss').toFormat('dd.MM.yyyy'),
            developer: app.Developer,
            developerLink: app.site_app
          }
        });
        this.allApp = mapResponse;
        this.filterApp.next(mapResponse);
        return mapResponse;
      })
    );
  }

  public filterPlatforms(): void {
    const selectedCategories = this.categories?.filter(x => x.isSelected);
    const selectedPlatform = this.platforms.filter(x => x.isSelected);

    let filterApp = this.allApp?.filter(
      app => selectedCategories?.some(c => c.title === app.category) && selectedPlatform.some(p => app.appStores.some(a => a.name === p.title))
    );

    const sorting = this.sorting;

    if (sorting.value === 'ASC') {
      filterApp = filterApp.sort(function (a, b) {
        if (a[sorting.type] < b[sorting.type]) {
          return -1;
        }
        if (a[sorting.type] > b[sorting.type]) {
          return 1;
        }
        return 0;
      });
    } else {
      filterApp = filterApp.sort(function (a, b) {
        if (a[sorting.type] > b[sorting.type]) {
          return -1;
        }
        if (a[sorting.type] < b[sorting.type]) {
          return 1;
        }
        return 0;
      });
    }

    this.filterApp.next(filterApp);
  }
}
